import {createFileRoute} from '@tanstack/react-router';

import EventEdit from '@/practitioner/views/event/EventEdit/EventEdit';

export const Route = createFileRoute('/(practitioner)/practitioner/events/$eventId')({
  component: EventEdit,
  loader: ({params}) => ({
    eventId: params.eventId
  })
});
